/** Icona sempre nera; testo nero se attivo, azzurro (--card-foreground) se no. */
export const NAV_ICON_CLASS = "text-foreground [&_svg]:text-foreground";

export function navLabelClass(active: boolean, underline = false) {
	const color = active ? "text-foreground" : "text-card-foreground";
	const line =
		underline && active ? "underline underline-offset-4 decoration-2" : "";
	return `${color} ${line}`.trim();
}

export function isNavHrefActive(pathname: string, href: string) {
	if (href === "/") return pathname === "/";
	if (href === "/area-riservata") return pathname === "/area-riservata";
	if (href === "/area-riservata/gallery") {
		return pathname === "/area-riservata/gallery";
	}
	return pathname === href || pathname.startsWith(`${href}/`);
}
